import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { visuallyHidden } from "@mui/utils";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import ConfirmBox from "../../UiComponents/ConfirmBox/ConfirmBox";
import { ToastError } from "../../UiComponents/Toaster/Toast";
import FloatLabel from "../../UiComponents/FloatLabel/FloatLabel";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {
  AccountBalanceWalletIcon,
  SearchIcon,
  EditIcon,
  DownloadIcon,
  CloudOffIcon,
  LockPersonIcon,
  RestartAltIcon,
} from "../../Resources/Icons/icons";
import moment from "moment";
import ManageWallet from "./ManageWallet";
import { Transition } from "../../UiComponents/Transition/Transition";
import Dialog from "@mui/material/Dialog";
import filterr from "../../Resources/Images/filter-lines.png";
import exportt from "../../Resources/Images/export.png";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  GetPolicyList,
  DeleteBranch,
  GetBranch,
  GetCompany,
  GetBookingCode,
  GetPolicyFindbyId,
  FilterPolicyList,
  GetUser,
  GetUserWallet,
  ReframeEndDateTimeFormat,
} from "../../Service/_index";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import CommonPayableDrawer from "../CommonPayableDrawer/CommonPayableDrawer";
import { checkUserType, filterOption } from "../../Shared/CommonConstant";
import Loader from "../../UiComponents/Loader/Loader";
import { DatePicker, Radio } from "antd";
import { CSVLink } from "react-csv";
import { useEffect } from "react";
import dayjs from "dayjs";
import { isAction } from "@reduxjs/toolkit";
import WalletPassword from "./WalletPassword";
import MasterCommonTable from "../../UiComponents/CommonTable/MasterCommonTable";
import { Divider, Stack, Badge } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterBox from "../../UiComponents/FilterBox/FilterBox";
import CustomButton from "../../UiComponents/CommonBUtton/ConfirmBox";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import wallett from "../../Resources/Images/wallet.png";

const { RangePicker } = DatePicker;

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    id: "userName",
    placeMent: true,
    disablePadding: false,
    label: "User",
  },
  {
    id: "branch",
    placeMent: true,
    disablePadding: false,
    label: "Branch",
  },
  {
    id: "walletBalance",
    placeMent: true,
    disablePadding: false,
    label: "Balance",
  },
  {
    id: "action",
    placeMent: false,
    disablePadding: false,
    label: "Action",
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  // return (
  //   // <TableHead>
  //   //   <TableRow>
  //   //     {headCells?.map((headCell) => (
  //   //       <TableCell
  //   //         className="TableHeader"
  //   //         key={headCell.id}
  //   //         align={headCell.placeMent ? "left" : "center"}
  //   //         padding={headCell.disablePadding ? "none" : "normal"}
  //   //         sortDirection={orderBy === headCell.id ? order : false}
  //   //         sx={{ fontSize: "16px", fontWeight: 600 }}
  //   //       >
  //   //         <TableSortLabel
  //   //           active={orderBy === headCell.id}
  //   //           direction={orderBy === headCell.id ? order : "asc"}
  //   //           onClick={createSortHandler(headCell.id)}
  //   //         >
  //   //           {headCell.label}
  //   //           {orderBy === headCell.id ? (
  //   //             <Box component="span" sx={visuallyHidden}>
  //   //               {order === "desc" ? "sorted descending" : "sorted ascending"}
  //   //             </Box>
  //   //           ) : null}
  //   //         </TableSortLabel>
  //   //       </TableCell>
  //   //     ))}
  //   //   </TableRow>
  //   // </TableHead>
  // );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const Wallet = () => {
  const UserType = sessionStorage.getItem("userType");
  // console.log(UserType, " UserType");
  // Changes by Arun
  let currentDate = new Date();
  let last7Days = new Date();
  last7Days.setDate(last7Days.getDate() - 7);
  const lastWeekDate = dayjs().subtract(7, "days").startOf("day");
  const todayDate = dayjs().startOf("day");
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [selectedData, setSelectedData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [openWalletPwdDrawer, setOpenWalletPwdDrawer] = React.useState(false); // Changes by Arun
  const [wallet, setWallet] = React.useState([]);
  const [openLoader, setOpenLoader] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(lastWeekDate);
  const [selectedEndDate, setSelectedEndDate] = useState(todayDate);
  const [isAllow, setIsAllow] = useState({});
  const [rowData, setRowData] = useState("");

  const [filterType, setFilterType] = useState(
    UserType === "user" ? "All" : undefined,
  );
  const [selectedUser, setSelecteduser] = useState("");
  const [userDetails, setUserDetails] = useState([]);
  // Branch Manager filter (same option scheme as the Master Report branch
  // filter): "manager_<userId>" / "branch_<branchId>" values.
  const [selectedBranchManager, setSelectedBranchManager] = useState(null);
  const [branchManagerDetails, setBranchManagerDetails] = useState([]);
  const [totalWallet, setTotalWallet] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [formType, setFormType] = useState("add");
  const [walletPassword, setWalletPassword] = useState("");
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [searchText, setSearchText] = useState("");
  const [tableConfig, setTableConfig] = useState({
    isSearch: true,
    isApprove: true,
    isMultiDelete: false,
    type: "userWallet",
  });
  const [originalData, setOriginalData] = useState([]);

  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(wallet), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, filter, wallet],
  );

  const activeFiltersCount = (() => {
    let c = 0;
    if (filterType) c += 1;
    if (selectedUser) c += 1;
    if (selectedBranchManager) c += 1;
    if (selectedStartDate && selectedEndDate) c += 1;
    return c;
  })();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const GetUserDetails = () => {
    const bodyData = {
      requesttype: "TABLE",
      isAscending: true,
    };
    GetUser(bodyData)
      .then((res) => {
        const FilteredData = res?.data
          .map((e) => {
            if (e.userType.includes("user")) {
              return {
                ...e,
                label: e.name + " - " + e.mobileNumber + " - " + e.email,
                value: e?._id,
              };
            } else {
              return null;
            }
          })
          .filter(Boolean);
        setUserDetails(FilteredData);
      })
      .catch((err) => ToastError("Network Error"));
  };

  // Build the Branch Manager filter options exactly like the Master Report
  // branch filter: one entry per manager ("Manager - Branch"); branches
  // without a manager are listed by branch name.
  const GetBranchManagerDetails = async () => {
    try {
      const [branchRes, userRes] = await Promise.all([
        GetBranch(),
        GetUser({ requesttype: "TABLE", isAscending: true }),
      ]);
      const branches = branchRes?.data || [];
      const users = userRes?.data || [];

      const FilteredData = [];

      branches.forEach((branch) => {
        if (branch.isEnabled) {
          // Find ALL managers assigned to this branch
          const managers = users.filter(
            (u) =>
              u.branchId &&
              u.branchId._id === branch._id &&
              u.userType &&
              Array.isArray(u.userType) &&
              u.userType.some((type) =>
                type.toLowerCase().includes("branchmanager"),
              ),
          );

          if (managers.length > 0) {
            // If the branch has managers, create an entry for each one
            managers.forEach((manager) => {
              FilteredData.push({
                _id: `manager_${manager._id}`, // UNIQUE ID FOR FILTERBOX
                label: `${manager.name} - ${branch.branchName}`,
                value: `manager_${manager._id}`,
                branchId: branch._id,
                branchName: branch.branchName,
                isManagerOption: true,
              });
            });
          } else {
            // No managers found, just list the branch itself
            FilteredData.push({
              _id: `branch_${branch._id}`, // UNIQUE ID FOR FILTERBOX
              label: branch.branchName,
              value: `branch_${branch._id}`,
              branchId: branch._id,
              branchName: branch.branchName,
              isManagerOption: false,
            });
          }
        }
      });

      setBranchManagerDetails(FilteredData);
    } catch (error) {
      console.error("Error fetching branch manager details:", error);
    }
  };

  useEffect(() => {
    GetUserDetails();
    GetBranchManagerDetails();
  }, []);

  const calculateSum = (arr) => {
    return arr?.reduce((total, current) => {
      return Number(total) + Number(current);
    }, 0);
  };

  // Changes by Arun
  const walletPasswordAction = () => {
    setFormType("add");
    setOpenWalletPwdDrawer(true);
  };

  // Changes by Arun
  const closeDialog = () => {
    setOpenWalletPwdDrawer(false);
    setOpenDrawer(true);
  };

  const onSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setSearchText(searchTerm);
    if (searchTerm === "") {
      setWallet(originalData);
    } else {
      const filteredData = originalData.filter((item) => {
        return Object.values(item).some(
          (value) =>
            value && value.toString().toLowerCase().includes(searchTerm),
        );
      });
      setWallet(filteredData);
    }
    setPage(0);
  };

  const [endDate, setEndDate] = useState(null);
  const GetData = async () => {
    setOpenLoader(true);
    // let endDate = null;
    let eDate = null;
    if (selectedEndDate) {
      eDate = await ReframeEndDateTimeFormat(selectedEndDate);
      setEndDate(eDate);
    }

    // For non-CLIENT users, use null (old method)
    const userIdParam = UserType === "CLIENT" ? selectedUser : null;

    // For non-CLIENT users, use null as filterType
    const filterTypeParam = UserType === "CLIENT" ? filterType : null;

    GetUserWallet(filterTypeParam, {
      userId: userIdParam,
      startDate: selectedStartDate,
      endDate: eDate,
      branchFilter: selectedBranchManager || null,
    })
      .then((res) => {
        setOpenLoader(false);
        const renderData = checkUserType(UserType);
        console.log("user type", renderData);

        const dataWithAction = res?.data.map((row) => ({
          ...row,
          action: (
            <Button onClick={() => handleStatementClick(row)}>Statement</Button>
          ),
        }));

        // Changes by Arun
        if (renderData.isUser) {
          setWallet(dataWithAction);
          setOriginalData(dataWithAction);
          setWalletPassword(res?.data[0]?.walletPassword ?? "");
        } else {
          setWallet(
            dataWithAction.filter((e) => {
              if (!selectedUser)
                return e?.walletBalance > 1 || e?.walletBalance < 0;
              else return e;
            }),
          );
          setOriginalData(
            dataWithAction.filter((e) => {
              if (!selectedUser)
                return e?.walletBalance > 1 || e?.walletBalance < 0;
              else return e;
            }),
          );
        }
        const totalWalletValues = res?.data.map((e) => e?.walletBalance);
        setTotalWallet(totalWalletValues);
        setPage(0);
      })
      .catch((err) => {
        setOpenLoader(false);
      });
  };

  // useEffect(() => {
  //   console.log("isAllow ", isAllow);
  //   if (isAllow.user) {
  //     GetData();
  //   }
  // useEffect(() => {
  //   console.log("isAllow ", isAllow);
  //   if (isAllow.user) {
  //     GetData();
  //   }
  // }, []);

  const header = [
    { label: "User Name", key: "userName" },
    { label: "Branch", key: "branch" },
    { label: "Wallet Balance", key: "walletBalance" },
  ];

  const csvFile = {
    filename: "User Wallet",
    headers: header,
    data: (wallet || []).map(({ action, ...rest }) => rest), // Exclude action column
  };

  const FilterOptions = [
    { _id: "Daily", label: "Daily Payout", value: "Daily" },
    {
      _id: "Weekly",
      label: "Weekly Payout",
      value: "Weekly",
    },
    {
      _id: "Monthly",
      label: "Monthly Payout",
      value: "Monthly",
    },
    {
      _id: "All",
      label: "All Payout",
      value: "All",
    },
  ];

  const filterBoxData = [
    {
      id: 1,
      label: "Filter Type ",
      data: FilterOptions,
      setState: setFilterType,
      value: filterType,
      type: "input",
      variation: "single",
    },
    {
      id: 2,
      label: "Select User",
      data: userDetails,
      setState: setSelecteduser,
      value: selectedUser,
      type: "input",
      variation: "single",
    },
    {
      id: 4,
      label: "Select Branch Manager",
      data: branchManagerDetails,
      setState: setSelectedBranchManager,
      value: selectedBranchManager,
      type: "input",
      variation: "single",
    },
    {
      id: 3,
      label: "Select Date",
      setDate: (e) => {
        console.log("edddddasd", e);
        setSelectedStartDate(e ? e[0] : null);
        setSelectedEndDate(e ? e[1] : null);
        setSearchTrigger((prev) => prev + 1);
      },
      type: "noDefaultDate",
      // defaultValue: [dayjs().subtract(7, "day"), dayjs()],
      // value: [selectedStartDate, selectedEndDate],
      defaultValue:
        selectedStartDate && selectedEndDate
          ? [selectedStartDate, selectedEndDate]
          : null,
    },
  ].filter((filter) => {
    const allowedForSelectUser = ["branchManager", "accountant"];
    // CLIENT users see all filters
    if (UserType === "CLIENT") {
      return true;
    }
    // Hide Select User for non-CLIENT users
    if (filter.id === 2 && !allowedForSelectUser.includes(UserType)) {
      return false;
    }
    // Branch Manager filter: only CLIENT and accountant can pick a manager
    // (a logged-in branch manager is already scoped to their own branch).
    if (filter.id === 4 && UserType !== "accountant") {
      return false;
    }
    // Hide Filter Type for user users
    if (UserType === "user") {
      if (filter.id === 1) {
        return false;
      }
    }
    return true;
  });

  const GetUnfilteredData = async () => {
    // Fetch data without any filters
    setOpenLoader(true);
    GetUserWallet(null, {
      userId: null,
      startDate: null,
      endDate: null,
      branchFilter: null,
    })
      .then((res) => {
        setOpenLoader(false);
        const renderData = checkUserType(UserType);
        const dataWithAction = res?.data.map((row) => ({
          ...row,
          action: (
            <Button onClick={() => handleStatementClick(row)}>Statement</Button>
          ),
        }));

        if (renderData.isUser) {
          setWallet(dataWithAction);
          setOriginalData(dataWithAction);
          setWalletPassword(res?.data[0]?.walletPassword ?? "");
        } else {
          setWallet(
            dataWithAction.filter((e) => {
              return e?.walletBalance > 1 || e?.walletBalance < 0;
            }),
          );
          setOriginalData(
            dataWithAction.filter((e) => {
              return e?.walletBalance > 1 || e?.walletBalance < 0;
            }),
          );
        }
        const totalWalletValues = res?.data.map((e) => e?.walletBalance);
        setTotalWallet(totalWalletValues);
        setPage(0);
      })
      .catch((err) => {
        setOpenLoader(false);
      });
  };

  const handleClearAllState = () => {
    setFilterType(null);
    setSelecteduser(null);
    setSelectedBranchManager(null);
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setDateRange(null);
    GetUnfilteredData();
    setSearchText("");
    setSearchTrigger((prev) => prev + 1);
  };

  const handleClearSingleFilter = async (filterId) => {
    if (filterId === 1) {
      // Clear filter type
      setFilterType(null);
      GetUnfilteredData();
      setSearchTrigger((prev) => prev + 1);
    } else if (filterId === 2) {
      // Clear user filter - show data with filter type only
      setSelecteduser(null);
      if (filterType) {
        // Call API with filterType but userId as null
        setOpenLoader(true);
        let endDateFormatted = null;
        if (selectedEndDate) {
          endDateFormatted = await ReframeEndDateTimeFormat(selectedEndDate);
        }
        GetUserWallet(filterType, {
          userId: null, // Explicitly pass null for userId
          startDate: selectedStartDate,
          endDate: endDateFormatted,
          branchFilter: selectedBranchManager || null,
        })
          .then((res) => {
            setOpenLoader(false);
            const renderData = checkUserType(UserType);
            const dataWithAction = res?.data.map((row) => ({
              ...row,
              action: (
                <Button onClick={() => handleStatementClick(row)}>
                  Statement
                </Button>
              ),
            }));

            if (renderData.isUser) {
              setWallet(dataWithAction);
              setOriginalData(dataWithAction);
              setWalletPassword(res?.data[0]?.walletPassword ?? "");
            } else {
              setWallet(
                dataWithAction.filter((e) => {
                  return e?.walletBalance > 1 || e?.walletBalance < 0;
                }),
              );
              setOriginalData(
                dataWithAction.filter((e) => {
                  return e?.walletBalance > 1 || e?.walletBalance < 0;
                }),
              );
            }
            const totalWalletValues = res?.data.map((e) => e?.walletBalance);
            setTotalWallet(totalWalletValues);
            setPage(0);
          })
          .catch((err) => {
            setOpenLoader(false);
          });
      } else {
        GetUnfilteredData();
      }
      setSearchTrigger((prev) => prev + 1);
    } else if (filterId === 3) {
      // Clear date filter
      setSelectedStartDate(null);
      setSelectedEndDate(null);
      setDateRange(null);
      if (filterType) {
        GetData();
      } else {
        GetUnfilteredData();
      }
      setSearchTrigger((prev) => prev + 1);
    } else if (filterId === 4) {
      // Clear Branch Manager filter; refetch with the remaining filters (the
      // searchTrigger effect runs AFTER the state update, so GetData sees the
      // cleared value).
      setSelectedBranchManager(null);
      if (filterType) {
        setSearchTrigger((prev) => prev + 1);
      } else {
        GetUnfilteredData();
      }
    }
  };

  const [searchTrigger, setSearchTrigger] = useState(0);
  const filterTypeRef = useRef(filterType);

  useEffect(() => {
    filterTypeRef.current = filterType;
  }, [filterType]);

  const handleSaveAllFilter = () => {
    if (filterTypeRef.current) {
      setSearchTrigger((prev) => prev + 1);
    } else {
      ToastError("Choose the filter type");
    }
  };

  useEffect(() => {
    if (searchTrigger > 0) {
      GetData();
    }
  }, [searchTrigger]);

  useEffect(() => {
    if (UserType === "user" && filterType === "All") {
      setSearchTrigger((prev) => prev + 1);
    }
  }, []);

  const handleStatementClick = (row) => {
    console.log("Row data for statement: ", row);
    if (isAllow.isUser && row.walletPassword) {
      setSelectedData(row);
      setFormType("check");
      setOpenWalletPwdDrawer(true);
    } else {
      setSelectedData(row);
      setOpenDrawer(true);
    }
  };

  React.useEffect(() => {
    const renderData = checkUserType(UserType);
    setIsAllow(renderData);
  }, [UserType]);

  return (
    <>
      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {/* Filter area toggled via Filters button */}
          {/* Table container below filter */}
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems="center"
                className="Master_Card_Sub_Container"
                spacing={2}
              >
                <Grid item xs={12} sm={6} md={6}>
                  <Typography className="Master_Card_Tittle">
                    User Wallet
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  className="d-flex justify-content-end"
                  gap={"8px"}
                >
                  <Stack
                    direction="row"
                    spacing={1}
                    sx={{ alignItems: "center" }}
                  >
                    {UserType !== "user" && (
                      <Button
                        className="Master_Card_Filter_Button"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <Badge
                            badgeContent={activeFiltersCount}
                            sx={{
                              "& .MuiBadge-badge": {
                                right: 5,
                                top: 3,
                                width: "14px",
                                height: "14px",
                                minWidth: "14px",
                                borderRadius: "50%",
                                fontSize: "8.91px",
                                fontWeight: "600",
                                backgroundColor: "#E50000",
                                color: "#fff",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              },
                            }}
                          >
                            <FilterListIcon sx={{ marginRight: "1.5px" }} />
                          </Badge>
                        }
                        onClick={() => setShowFilter((s) => !s)}
                        size="small"
                        variant="outlined"
                      >
                        Filters
                      </Button>
                    )}
                    {UserType === "user" && (
                      <Button
                        className="Master_Card_Filter_Button"
                        sx={{
                          width: "160px",
                          height: "40px",
                          gap: "8px",
                          display: walletPassword ? "none" : "flex",
                        }}
                        startIcon={<LockPersonIcon sx={{ color: "#344054" }} />}
                        size="small"
                        variant="outlined"
                        onClick={walletPasswordAction}
                      >
                        Wallet Password
                      </Button>
                    )}
                    <Button
                      className="Master_Card_Filter_Button"
                      sx={{ width: "102px", height: "40px", gap: "8px" }}
                      startIcon={
                        <CloudDownloadOutlinedIcon
                          sx={{
                            color: "#344054",
                          }}
                        />
                      }
                      size="small"
                      variant="outlined"
                    >
                      <CSVLink
                        style={{ textDecoration: "none", color: "inherit" }}
                        {...csvFile}
                      >
                        Export
                      </CSVLink>
                    </Button>
                  </Stack>
                </Grid>
              </Grid>

              {/* Filter Section (toggled) */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                    autoApply={false}
                  />
                </Box>
              )}

              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>
              <Grid
                container
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Grid
                  item
                  marginLeft={2}
                  margin={1}
                  sx={{
                    backgroundColor: "#F0F5FA",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    padding: "2px",
                    paddingRight: "15px",
                    paddingLeft: "15px",
                    gap: "10px",
                    border: "1px solid #DFE7F1",
                  }}
                >
                  <Grid>
                    <img src={wallett} width="18px" height="17px" />
                  </Grid>
                  <Grid>
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontWeight: "500",
                        color: "#1E3A5F",
                        fontSize: 16,
                        lineHeight: "1.2",
                      }}
                    >
                      ₹ {calculateSum(totalWallet?.map((value) => value))}
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontWeight: "500",
                        color: "#667085",
                        fontSize: 12,
                        lineHeight: "1.2",
                      }}
                    >
                      Total Wallet
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={4} md={3.1} margin={1}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    onChange={(e) => {
                      onSearch(e);
                      setPage(0);
                    }}
                    disableUnderline={true}
                    placeholder="Search in Access"
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
              <MasterCommonTable
                tableConfig={tableConfig}
                data={wallet}
                columns={headCells}
                loading={openLoader}
                paginationReset={searchText + searchTrigger}
                // isServerSide={true}
                // handleEdit={EditCompanyData}
                // handleView={ViewCompanyData}
                // handleDelete={DeleteCompanyData}
                // handleApprove={ActiveCompanyData}
                // tableTotalCount={filter.fn(company)?.length || 0}
                // tableOutputEvent={tableOutputEvent}
              />
            </Grid>
          </Box>
        </Box>
      </div>
      {/* <Loader open={openLoader} /> */}
      <Drawer
        open={openDrawer}
        sx={{
          zIndex: 100,
        }}
        anchor="right"
        PaperProps={{
          sx: { width: { xs: "100%", sm: "100%", md: "100%" } },
        }}
      >
        {openDrawer ? (
          <ManageWallet
            setOpenDrawer={setOpenDrawer}
            selectedData={selectedData}
            formType={selectedData?._id ? "edit" : "add"}
            GetData={GetData}
            startDate={selectedStartDate}
            endDate={selectedEndDate}
            totalWallet={totalWallet}
            calculateSum={calculateSum}
          />
        ) : null}
      </Drawer>
      <Dialog
        open={openWalletPwdDrawer}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            maxWidth: "30%",
          },
        }}
      >
        {openWalletPwdDrawer ? (
          <WalletPassword
            setOpenDrawer={setOpenWalletPwdDrawer}
            formType={formType}
            selectedData={selectedData}
            GetData={GetData}
            title={
              formType == "add"
                ? "Create"
                : formType == "check"
                  ? "Enter"
                  : "Edit"
            }
            closeDialog={closeDialog}
          />
        ) : null}
      </Dialog>
    </>
  );
};
export default Wallet;
